import { ITitleTextAsProps } from '../../../../../sp-types/routeDetailsType';
import React from 'react';

export const InputRouteDetailsTextBox: React.FC<ITitleTextAsProps> = ({ text, title, update = () => {} }) => {
  return (
    <div className="p-2 border border-gray-150 rounded-md leading-4 flex-1">
      <input
        type="text"
        className="flex-1  w-full"
        value={title}
        onChange={(event) => {
          const newTitle = event.target.value;
          update({ title: newTitle, text });
        }}
      />
      <textarea
        className="text-sm text-secondary flex-1  w-full"
        value={text}
        onChange={(event) => {
          const newText = event.target.value;
          update({ title, text: newText });
        }}
      />
    </div>
  );
};
